module.exports = __webpack_public_path__ + "img/pattern1.d1e26ad.svg";